import { Subscription } from 'rxjs';
import { ParentBusiness, SystemBusiness } from 'fccore2';
import { ViewChild, Input } from '@angular/core';

export class Fcomponent {
    @ViewChild('fcRef', {static: false})
    fcRef: any;
    fcId: string;
    @Input()
    fcUuid: string;
    pId: string;
    appId: string;
    data: any;
    unsubscribes: any[] = [];
    /**
     * å¸¦æ³¨éçè®¢éäºä»¶
     * @param subscribe å¾æ³¨é
     */
    pushDestroy(subscribe: Subscription): void {
        this.unsubscribes.push(subscribe);
    }

    /**
     * åæ¶äºä»¶è®¢é
     */
    ngOnDestroy() {
        ParentBusiness.unsubscribes(this.unsubscribes);
        // CacheService.set(this.moduleId + this.appId + 'DATA', this.data);
        this.data = null;
    }
    /**
     * å³é­æç¦»å¼æ¶è°ç¨,å½è¿åtrueå¯ä»¥å³é­ï¼å¦åä¸è½å³é­å½åé¡µé¢
     */
    public canClosed(context: any): boolean {
        return true;
    }
    /**
     * åå§åå¯¹è±¡åå®¹
     * @param data è¿åæä¸ªå°åä¸ä¸æ ·çæ°æ®
     */
    public setData(data: any): any {
        return {
            pId: '',
            mId: '',
            /** å½åä¸»åºç¨id */
            aId: '',
            /** è·¯ç±åæ° */
            param: SystemBusiness.activatedRoute.snapshot.params,
            /** ç¨æ·ä¿¡æ¯ */
            userInfo: ParentBusiness.getUserinfo()
            , ...data };
    }
}
